import classNames from 'classnames';
import { forwardRef } from 'react';
import type { ReactNode } from 'react';

import footerImg from './assets/footer.webp';
import { LockSvg } from './LockSvg';
import { Spinner } from '../Spinner';

import './pay-button.scss';

interface Props {
  onClick: () => void;
  buttonLabel: string;
  terms: ReactNode;
  termsBottom?: ReactNode;
  variant?: 'primary' | 'loading';
  disabled?: boolean;
}

export const PayButton = forwardRef<HTMLButtonElement, Props>(
  ({ onClick, variant, buttonLabel, terms, termsBottom, disabled }, ref) => {
    const isLoading = variant === 'loading';

    return (
      <div className="payflow-presentation pay-button-container">
        <div className="pay-button__ack">{terms}</div>

        <div className="pay-button__btn_container">
          <button
            ref={ref}
            className={classNames('pay-button__btn', isLoading && 'btn-loading')}
            onClick={onClick}
            disabled={disabled || isLoading}
          >
            {isLoading ? <Spinner size="lg" /> : <LockSvg />}
            <span>{buttonLabel}</span>
          </button>
        </div>

        <div>
          <img src={footerImg} alt="payment methods" />
        </div>
        {termsBottom && <div className="pay-button__ack-bottom">{termsBottom}</div>}
      </div>
    );
  }
);
